
import { get, post, postBlob } from '@/utils/apiBase.js';

// 获取众筹和创意项目列表（step1）
const getDrawItemList = option => {
    return get('/apis/project/cp_admin/get_item_list', option)
}
// cp后台获取创意信息
const getDrawIdeaInfo = option => {
    return get('/apis/project/cp_admin/idea_info', option)
}
// 保存抽奖预览信息
const addRaffleActivityPreview = (option) => {
    return post('/apis/project/cp_admin/add_raffle_activity_preview', option)
}
const getMiniAppQrcode = (option) => {
    return post('/apis/project/get_mini_app_qrcode', option)
}
// 发布抽奖
const addRaffleActivity = (option) => {
    return post('/apis/project/cp_admin/add_raffle_activity', option)
}
// 获取抽奖活动列表
const getDrawActivityList = option => {
    return get('/apis/project/cp_admin/activity_list', option)
}
// 查询当前项目ID绑定的抽奖活动列表（编辑器添加抽奖用）
const getActivityListByItemId = option => {
    return get('/apis/project/cp_admin/get_activity_list_by_item_id', option)
}
// 获取编辑器内抽奖卡片信息
const getActivityCardInfo = option => {
    return get('/apis/project/cp_admin/get_activity_card_info', option)
}
// 抽奖活动详情页
const getActivityInfoApp = option => {
    return get('/apis/project/activity_info', option)
}
// 奖品数
const getPrizeIndex = option => {
    return get('/pro_draw/main/prize_index', option)
}
// 中奖名单
const postWinList = (option) => {
    return post('/pro_draw/main/win_list', option)
}
// 提醒用户填地址
const getNotifyAddAddress = option => {
    return get('/pro_draw/main/notify_add_address', option)
}
// 发放奖品的物流公司
const getDrawExpressList = option => {
    return get('/pro_draw/main/express_company_list', option)
}
// 物流状态
const getMdlogisticsInfos = option => {
    return get('/apis/mdlogistics/infos', option)
}
// 发放奖品
const getUploadDeliverGoods = option => {
    return get('/pro_draw/main/upload_deliver_goods', option)
}
// 导出
const exportWinInfo = (option) => {
    return postBlob('/pro_draw/main/export_win_info', option)
}
export default {
    getDrawItemList,
    getDrawIdeaInfo,
    addRaffleActivityPreview,
    getMiniAppQrcode,
    addRaffleActivity,
    getDrawActivityList,
    getActivityListByItemId,
    getActivityCardInfo,
    getActivityInfoApp,
    getPrizeIndex,
    postWinList,
    getNotifyAddAddress,
    getDrawExpressList,
    getMdlogisticsInfos,
    getUploadDeliverGoods,
    exportWinInfo
}
